import { locale } from './containers/LocaleProvider';

export const __ = toTranslate => {
  if (toTranslate in locale.translations[locale.lang]) {
    return locale.translations[locale.lang][toTranslate];
  }
  return toTranslate;
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhone = phone => {
  const re = /^[0-9+ ]+$/;
  return re.test(String(phone));
};

export const containsCyrillic = str => {
  const cyrillicRe = new RegExp(/[а-яА-ЯЁё]/);
  return cyrillicRe.test(String(str));
};

export const getProp = (object, path, defaultValue = '') => {
  const val = path.reduce((o, x) => {
    return typeof o === 'undefined' || o === null ? defaultValue : o[x];
  }, object);
  if (typeof val === 'undefined' || val === null) {
    return defaultValue;
  }
  return val;
};

export const formatNumber = (n, c = 2, d = ',', t = ' ') => {
  const s = n < 0 ? '-' : '';
  const b = Math.abs(+n || 0);
  const i = String(parseInt(b.toFixed(c), 10));
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
    (c
      ? d +
        Math.abs(b - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};

export const formatPrice = (
  n,
  currency = 'EUR',
  c = 2,
  d = ',',
  t = '\u00a0',
) => {
  if (currency === 'CZK') {
    return `${formatNumber(n, c, d, t, c)} Kč`;
  } else if (currency === 'EUR') {
    return `${formatNumber(n, c, d, t, c)} €`;
  }
  return `${formatNumber(n, c, d, t, c)} ${currency}`;
};

export const calucateTotalPriceForSectors = sectors => {
  return sectors.reduce((acc, sector) => {
    const price = Number.parseFloat(getProp(sector, ['tarrifs', 0, 'price']));
    if (price && !Number.isNaN(price)) {
      if (acc === null) {
        return 0 + price;
      }
      return acc + price;
    }
    return acc;
  }, null);
};



// WEBPACK FOOTER //
// ./src/utilities.js